import { LoadablePaint } from '@confluence/loadable';

export const PageIncludeSSRExtensionHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageIncludeSSRExtensionHandler" */ '../src/PageIncludeSSRExtensionHandler.tsx'
			)
		).PageIncludeSSRExtensionHandler,
});
